import React from 'react';
import { HeadphonesIcon } from 'lucide-react';
import { TroveGenrePage } from '../../components/Trove/TroveGenrePage';
import type { TroveArticle } from '../../components/Trove/TroveGenrePage';
import type { ActivityPost } from '../../components/Trove/ActivityPostCard';
const activityPosts: ActivityPost[] = [{
  id: 1,
  type: 'Audiobook Launch',
  title: 'Project Hail Mary — Full Cast Audio',
  description: "Andy Weir's beloved sci-fi adventure now available as a full cast audiobook production.",
  author: 'Andy Weir',
  date: 'Oct 14, 2023',
  genre: 'Science Fiction'
}, {
  id: 2,
  type: 'New Release',
  title: 'Fourth Wing — Graphic Audio',
  description: 'Experience the phenomenon with full sound effects and cinematic music.',
  author: 'Rebecca Yarros',
  date: 'Oct 12, 2023',
  genre: 'Fantasy'
}, {
  id: 3,
  type: 'Vendor Availability',
  title: 'Professional Narrator — Open for Bookings',
  description: 'Award-winning narrator with home studio. Specializing in romance and fantasy.',
  author: 'Sarah Voice',
  date: 'Oct 10, 2023',
  genre: 'Romance'
}];
const articles: TroveArticle[] = [{
  id: 1,
  title: 'Voice Acting Essentials',
  excerpt: 'A comprehensive guide to getting started in audiobook narration...',
  author: 'Sarah Johnson',
  date: 'October 7, 2023',
  category: 'Narration',
  readTime: '12 min read',
  image: 'https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  id: 2,
  title: 'Studio Setup for Beginners',
  excerpt: 'Everything you need to create a professional home recording studio...',
  author: 'Mike Rodriguez',
  date: 'October 4, 2023',
  category: 'Technical',
  readTime: '15 min read',
  image: 'https://images.unsplash.com/photo-1598653222000-6b7b7a552625?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}];
const interviews: TroveArticle[] = [{
  id: 107,
  title: 'Julia Whelan on Bringing Characters to Life Through Voice',
  excerpt: 'The award-winning narrator discusses her approach to different characters and genres...',
  author: 'Audiobook Monthly',
  date: 'October 9, 2023',
  category: 'Narration',
  readTime: '16 min read',
  image: 'https://images.unsplash.com/photo-1590086783191-a0694c7d1e6e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  type: 'interview'
}, {
  id: 108,
  title: 'Simon Vance on the Evolution of Audiobook Production',
  excerpt: 'The veteran narrator reflects on changes in the industry over his decades-long career...',
  author: 'Voice Arts Today',
  date: 'October 3, 2023',
  category: 'Industry',
  readTime: '14 min read',
  image: 'https://images.unsplash.com/photo-1508700115892-45ecd05ae2ad?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  type: 'interview'
}];
const podcasts: TroveArticle[] = [{
  id: 207,
  title: 'Audiobook Lounge',
  excerpt: 'Weekly discussions with narrators, producers, and industry professionals...',
  author: 'Rebecca Thompson',
  date: 'Weekly',
  category: 'Industry',
  readTime: '50-60 min episodes',
  image: 'https://images.unsplash.com/photo-1487180144351-b8472da7d491?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  type: 'podcast'
}, {
  id: 208,
  title: "The Narrator's Voice",
  excerpt: 'Techniques, tips, and career advice for aspiring and established narrators...',
  author: 'James Wilson',
  date: 'Bi-weekly',
  category: 'Career',
  readTime: '40-45 min episodes',
  image: 'https://images.unsplash.com/photo-1508700929628-666bc8bd84ea?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  type: 'podcast'
}];
const AudioTrove = () => <TroveGenrePage title="Audio & Narration" subtitle="Resources and insights for audiobook narrators and producers" icon={<HeadphonesIcon className="h-6 w-6" data-id="element-15837" data-mp="24vlijbuqqlep" />} searchPlaceholder="Search audio & narration content..." activityPosts={activityPosts} activityTitle="Latest Audio News" articles={articles} interviews={interviews} podcasts={podcasts} featuredSectionTitle="Featured Audio Guide" interviewsTabLabel="Narrator Interviews" podcastsTabLabel="Industry Podcasts" data-id="element-15836" data-mp="36jyt6mx6ymm8" />;
export default AudioTrove;